import * as React from 'react';
import { BaseComponent } from '../BaseComponent';
import { PconLoginStore } from '../../stores/PconLoginStore';
import { VisibilityStore } from '../../stores/VisibilityStore';
import { Overlay } from '../../constants/Enums';
import { VisibilityActions } from '../../actions/VisibilityActions';
import { OverlayCloseButton } from './OverlayCloseButton';
import { UIHelper } from '../../utils/UIHelper';

interface PconLoginIframeState {
    loggedIn: boolean;
}

export class PconLoginIframe extends BaseComponent<{}, PconLoginIframeState> {
    public componentWillMount(): void {
        this.addStoreListener(PconLoginStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.loggedIn) {
            setTimeout(
                (): void => {
                    if (VisibilityStore.getState().overlay === Overlay.LOGIN) {
                        VisibilityActions.changeOverlay(Overlay.NONE);
                    }
                },
                1
            );
            return null;
        }
        return (
            <div className="overlay-frame overlay-full">
                <div className="overlay-content">
                    <OverlayCloseButton
                        show={true}
                        callback={this.onCloseClick}
                    />
                    <iframe src={PconLoginStore.getAuthUrl()} style={{width: '100%', height: '100%'}}/>
                </div>
            </div>
        );
    }

    protected onCloseClick = async (): Promise<void> => {
        await UIHelper.blurKeyboard();
        VisibilityActions.changeOverlay(Overlay.NONE);
    };

    protected onChange = (): void => {
        this.setState({
            loggedIn: PconLoginStore.isLoggedIn()
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/overlay/PconLoginIframe.tsx